<template>
  <div class="modal register-modal">
    <div class="overlay"  @click="$parent.closePersonalInfoModal"></div>
    <div class="wrapper">
<!--      <img class="close" @click="$parent.closePersonalInfoModal" src="./../images/close.svg"/>-->
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="title">Checkout</div>
                <label>
                  <div class="desc align-left">*First name</div>
                  <input type="text" placeholder="First name" v-model="name"/>
                </label>
                <label>
                  <div class="desc align-left">*Last Name</div>
                  <input type="text" placeholder="Last Name" v-model="surname"/>
                </label>
                <label v-if="!$parent.fiatToCrypto" >
                <div class="desc align-left">*Birthdate</div>
                <input type="date" placeholder="Last Name" v-model="birthdate"/>
                </label>
                <label>
                  <div class="desc align-left">*Email</div>
                  <input type="email" placeholder="Email" v-model="email"/>
                </label>
                <label>
                  <div class="desc align-left">*Phone</div>
                  <input type="tel" placeholder="Phone" v-model="phone"/>
                </label>
                <label>
                  <div class="desc align-left">*Address</div>
                  <input type="text" placeholder="Address" v-model="address"/>
                </label>
                <label>
                  <div class="desc align-left">*City</div>
                  <input type="text" placeholder="City" v-model="city"/>
                </label>
                <label>
                  <div class="desc align-left">*Post code</div>
                  <input type="email" placeholder="Post code" v-model="postCode"/>
                </label>
                <label>
                  <div class="desc align-left">*Country</div>
                  <!-- <Select2 class="select2 single" v-model="country" 
                  :options="countryOptions" 
                  @select="selectCountry($event)"
                  placeholder="Country"
                  /> -->
                  <select v-model="country">
                    <option disabled selected value="">Country</option>
                    <option v-for="(item, i) in countryOptions" :value="item" :key="i">{{ item.title }}</option>
                  </select>
                </label>
                <div class="link-container">
                  <div class="chekbox-container">
                    <label class="chekbox-label">
                      <div class="chekbox-label-wrapper">
                        <input type="checkbox" name="terms" v-model="terms"/>
                        <div class="checkbox"></div>
                        <span class="desc">I agree with </span>
                        <a @click="$parent.goToPrivacy()" class="desc link"> privacy policy</a>
                        <span class="desc"> and </span>
                        <a @click="$parent.goToTerms()" class="desc link"> terms and conditions</a>
                      </div>
                    </label>
                  </div>
                </div>
                <button :class="['button', {'disabled': !requiredRegisterFieldsAreFilled}]" @click="submit">
                  <span>Submit</span>
                </button>
                <div v-if="$parent.error" class="desc red">{{$parent.error}}</div>
<!--                <div class="legal-info">-->
<!--                  <div class="info">{{ $parent.legalInfo }}</div>-->
<!--                  <div class="billing-descriptor">-->
<!--                    {{ $parent.billingDescriptor }}-->
<!--                  </div>-->
<!--                  <div class="vsmc">-->
<!--                    <img src="@/images/mc.svg" class="img"/>-->
<!--                    <img src="@/images/visa.svg" class="img"/>-->
<!--                  </div>-->
<!--                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

// import Select2 from 'vue3-select2-component';
export default {
  name: 'PersonalInfoModal',
  props: [],
  components: {
    // Select2
  },
  data: function() {
    return {
      countryOptions: [],
      countryOptionsId: [],
      email: '',
      name: '',
      surname: '',
      birthdate: null,
      phone: '',
      country: '',
      countryId: '',
      city: '',
      address: '',
      postCode: '',
      terms: false

    }
  },
  mounted() {
    this.$http.get(process.env.VUE_APP_API + 'user/profile')
      .then((res) => {
          this.email = res.data.email;
          this.name = res.data.name;
          this.surname = res.data.surname;
      })
      .catch(() => {
        
      })
      this.getCountries();
  },
  computed: {
    requiredRegisterFieldsAreFilled() {
      let fieldsAreFilled;

      if(
        this.name && this.surname  && this.phone && 
        this.email && this.terms && this.city && this.country && 
        this.postCode && this.address  && (this.$parent.fiatToCrypto || this.birthdate)
      ) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    }
  },
  methods: {
    selectCountry(event) {
      this.country = event.text;
      for (let i = 0; i < this.countryOptions.length; i++) {
        if (this.countryOptions[i] == event.text) {
          this.countryId = this.countryOptionsId[i];
        }
      }
    },
    getCountries() {
      this.$http.get(process.env.VUE_APP_API + 'countries')
      .then((res) => {
          this.countryOptions = res.data.payload;
      })
      .catch((res) => {
        if(res.response.status === 401) {
          this.$parent.openSignInModal();
        }
      })
    },
    submit() {
      this.$emit('setPersonalInfo', this.email, this.name, this.surname, this.phone, this.postCode, this.country.id, this.city, this.address, this.birthdate)
      this.$emit('orderSubmit');
    },
  }
}
</script>